import { Spin } from 'antd';
import { Suspense, lazy } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import Layout from '../../../../../../../components/Layout';
import Menu from '../../../../../../../components/Layout/Menu';

const QuestionnaireContent = lazy(
  () => import(
    '../../../../../../../components/Pages/Categories/[categoryId]/SubCategories/[subCategoryId]/Update/Questionnaire'
  ),
);

export default function SubCategoryQuestionnaire(): JSX.Element | null {
  document.title = `${process.env.REACT_APP_TITLE}: Questionnaire`;

  return (
    <Layout LeftMenu={Menu} transparent>
      <Suspense fallback={<Spin spinning indicator={<LoadingOutlined spin />} />}>
        <QuestionnaireContent />
      </Suspense>
    </Layout>
  );
}
